import {makeAutoObservable} from "mobx";



const dialogFunctionModel = {
    clickButton: undefined,
    dialogClose: undefined,
    disabledButton: false,
    controlBtnText: "",
    controlBtn: false,
    dialogOpen: false,
    contentType: "",
    titleText: "",
    text: "",
}

export default class DialogStore {

    constructor() {
        this.init();
        makeAutoObservable(this);
    }


    init = () => {
        this.dialog = JSON.parse(JSON.stringify(dialogFunctionModel));
        this.errorDialog = JSON.parse(JSON.stringify(dialogFunctionModel));
        this.dialogStatus = false;
    }
    closeDialog = (additionalAction) => {
        this.init();
        additionalAction && additionalAction ();
    }
    setDialog = (info) => {
        this.dialog = info;
    }
    setErrorDialog = (info) => {
        this.errorDialog = info;
    }
    setDialogStatus = (bool) => {
        this.dialogStatus = bool;
    }


    setDialogButtonFunction = (defaultButtonFunction, additionalButtonFunction) => {
        console.log("setDialogButtonFunction");
        defaultButtonFunction && defaultButtonFunction();
        additionalButtonFunction && additionalButtonFunction();
    }

    // openNewDialog = ({titleText, contentType, text, controlBtn, clickButton, controlBtnText, disabledButton = false, additionalActionOnConfirm= undefined, additionalActionOnClose = undefined,}) => {
    openNewDialog = ({titleText, contentType, text, controlBtn, clickButton, controlBtnText, disabledButton = false, additionalActionOnConfirm= undefined, additionalActionOnClose = undefined,}) => {
        this.setDialogStatus(true);
        this.setDialog({
            dialogOpen: this.dialogStatus,
            dialogClose: () => this.closeDialog(additionalActionOnClose),
            titleText :titleText,
            contentType :contentType,
            text :text,
            controlBtn :controlBtn,
            clickButton :() => this.setDialogButtonFunction(clickButton,additionalActionOnConfirm),
            controlBtnText :controlBtnText,
            disabledButton :disabledButton,
        });
    }

    openErrorDialog = ({titleText, text}) => {
        this.setErrorDialog({
            dialogOpen: true,
            dialogClose: () => this.closeDialog(),
            titleText :titleText,
            text :text,
        });
    }
}
